import { createActionsHook } from 'src/lib/sweetState';

import { FreestyleToolsStore } from './FreestyleToolsStore';

export const useFreestyleToolsActions = createActionsHook(FreestyleToolsStore);
